<div class="uw-container uw-min-w-readable tw-flex tw-flex-col tw-px-2 tw-gap-4">
  @if(business !== undefined) {
  @if(business === null) {
  <!-- <brt-business-list (selected)="router.navigate([basePath, 'promotion', $event.Id])"></brt-business-list> -->
  }
  <div class="card">
    <h5>Payment List</h5>
    <p-table  [value]="payments" dataKey="id" [rows]="limit" [loading]="loading" [rowHover]="true"
      styleClass="p-datatable-gridlines" [paginator]="true"   [rowsPerPageOptions]="[10, 20, 50, 100, 500, 1000]" [totalRecords]="total" [globalFilterFields]="[]"
      responsiveLayout="scroll" [lazy]="true">
      <ng-template pTemplate="header">
        <tr>
          <th> Time </th>
          <th> Status </th>
          <th> Amount </th>
          <th> Fee </th>
          <th> Payable </th>
          <th> Payment Method </th>
          <th> </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-payment>
        <tr>
          <td>{{payment.RegisterTime|date:'short'}}</td>
          <td>
            @switch (payment.Status) {
            @default { {{payment.Status}} }
            @case ('Refund') { @if(payment.IsRefunded){Refunded}@else{ To Refund } }
            }
          </td>
          <td>{{payment.Amount}}</td>
          <td>{{payment.Fee}}</td>
          <td>{{payment.Paid}}</td>
          <td>{{payment.PaymentMethod || (payment.IsCash ? 'Cash' : 'Not specified')}}</td>
          <td></td>
        </tr>
      </ng-template>
    </p-table>
  </div>
  }
</div>
